export const thresholds = {
  hardwareConcurrency: { high: 8, medium: 4 },
  deviceMemory: { high: 8, medium: 6, low: 4 },
  gpuTier: { high: 3, medium: 2 },
  pixelRatio: { high: 3, medium: 2 },
};

export const weights = {
  hardwareConcurrency: 3,
  deviceMemory: 3,
  gpuTier: 3,
  pixelRatio: 1,
};

export const scores = {
  high: {
    threshold: 8,
    value: 1,
  },
  medium: {
    threshold: 5,
    value: 2,
  },
  low: {
    value: 3,
  },
};

export const gpuLevels: Record<number, 'LOW' | 'MEDIUM' | 'HIGH'> = {
  1: 'LOW', 2: 'MEDIUM', 3: 'HIGH',
};

export const gpuMemoryMap: Record<string, number> = {
  'apple a8 gpu': 1,
  'apple a9 gpu': 2,
  'apple a10 gpu': 2,
  'apple a11 gpu': 3,
  'apple a12 gpu': 3,
  'apple a13 gpu': 4,
  'apple a14 gpu': 4,
  'apple a15 gpu': 4,
  'apple a16 gpu': 6,
  'apple a17 gpu': 8,
  'apple a17 pro gpu': 8,
};
